module.exports = {
  MONTHS: [
    {
      value: '01',
      label: 'January'
    },
    {
      value: '02',
      label: 'February'
    },
    {
      value: '03',
      label: 'March'
    },
    {
      value: '04',
      label: 'April'
    },
    {
      value: '05',
      label: 'May'
    },
    {
      value: '06',
      label: 'June'
    },
    {
      value: '07',
      label: 'July'
    },
    {
      value: '08',
      label: 'August'
    },
    {
      value: '09',
      label: 'September'
    },
    {
      value: '10',
      label: 'October'
    },
    {
      value: '11',
      label: 'November'
    },
    {
      value: '12',
      label: 'December'
    }
  ],
  STATES: [
    { label: 'Alabama', code: 1, value: 'AL' },
    { label: 'Alaska', code: 2, value: 'AK' },
    { label: 'American Samoa', code: 3, value: 'AS' },
    { label: 'Arizona', code: 4, value: 'AZ' },
    { label: 'Arkansas', code: 5, value: 'AR' },
    { label: 'California', code: 6, value: 'CA' },
    { label: 'Colorado', code: 7, value: 'CO' },
    { label: 'Connecticut', code: 8, value: 'CT' },
    { label: 'Delaware', code: 9, value: 'DE' },
    { label: 'District of Columbia', code: 10, value: 'DC' },
    { label: 'Federated States of Micronesia', code: 11, value: 'FM' },
    { label: 'Florida', code: 12, value: 'FL' },
    { label: 'Georgia', code: 13, value: 'GA' },
    { label: 'Guam', code: 14, value: 'GU' },
    { label: 'Hawaii', code: 15, value: 'HI' },
    { label: 'Idaho', code: 16, value: 'ID' },
    { label: 'Illinois', code: 17, value: 'IL' },
    { label: 'Indiana', code: 18, value: 'IN' },
    { label: 'Iowa', code: 19, value: 'IA' },
    { label: 'Kansas', code: 20, value: 'KS' },
    { label: 'Kentucky', code: 21, value: 'KY' },
    { label: 'Louisiana', code: 22, value: 'LA' },
    { label: 'Maine', code: 23, value: 'ME' },
    { label: 'Maryland', code: 24, value: 'MD' },
    { label: 'Massachusetts', code: 25, value: 'MA' },
    { label: 'Michigan', code: 26, value: 'MI' },
    { label: 'Minnesota', code: 27, value: 'MN' },
    { label: 'Mississippi', code: 28, value: 'MS' },
    { label: 'Missouri', code: 29, value: 'MO' },
    { label: 'Montana', code: 30, value: 'MT' },
    { label: 'Nebraska', code: 31, value: 'NE' },
    { label: 'Nevada', code: 32, value: 'NV' },
    { label: 'New Hampshire', code: 33, value: 'NH' },
    { label: 'New Jersey', code: 34, value: 'NJ' },
    { label: 'New Mexico', code: 35, value: 'NM' },
    { label: 'New York', code: 36, value: 'NY' },
    { label: 'North Carolina', code: 37, value: 'NC' },
    { label: 'North Dakota', code: 38, value: 'ND' },
    { label: 'Northern Mariana Islands', code: 39, value: 'MP' },
    { label: 'Ohio', code: 40, value: 'OH' },
    { label: 'Oklahoma', code: 41, value: 'OK' },
    { label: 'Oregon', code: 42, value: 'OR' },
    { label: 'Palau', code: 43, value: 'PW' },
    { label: 'Pennsylvania', code: 44, value: 'PA' },
    { label: 'Puerto Rico', code: 45, value: 'PR' },
    { label: 'Rhode Island', code: 46, value: 'RI' },
    { label: 'South Carolina', code: 47, value: 'SC' },
    { label: 'South Dakota', code: 48, value: 'SD' },
    { label: 'Tennessee', code: 49, value: 'TN' },
    { label: 'Texas', code: 50, value: 'TX' },
    { label: 'Utah', code: 51, value: 'UT' },
    { label: 'Vermont', code: 52, value: 'VT' },
    { label: 'Virginia', code: 53, value: 'VA' },
    { label: 'Washington', code: 54, value: 'WA' },
    { label: 'West Virginia', code: 55, value: 'WV' },
    { label: 'Wisconsin', code: 56, value: 'WI' },
    { label: 'Wyoming', code: 57, value: 'WY' }
  ],
  GENDERS: [
    {
      label: 'Male',
      value: 'Male'
    },
    {
      label: 'Female',
      value: 'Female'
    }
  ],
  AGE_TYPES: [
    {
      label: 'Age',
      value: 'Age'
    },
    {
      label: 'DOB',
      value: 'DOB'
    }
  ],
  TOBACCO_OPTIONS: [
    {
      label: 'No',
      value: false
    },
    {
      label: 'Yes',
      value: true
    }
  ],
  NON_TOBACCO: ['Preferred Plus', 'Preferred', 'Standard Plus', 'Standard'],
  TOBACCO: ['Preferred', 'Standard'],
  RIDERS: ['Accidental Death Benefit', 'Waiver of Premium'],
  SORT_OPTIONS: [
    {
      value: 'premium_annual',
      label: 'Premium: Annual'
    },
    {
      value: 'premium_semi_annual',
      label: 'Premium: Semi-Annual'
    },
    {
      value: 'premium_quarterly',
      label: 'Premium: Quarterly'
    },
    {
      value: 'premium_monthly',
      label: 'Premium: Monthly'
    },
    {
      value: 'carrier_name',
      label: 'Carrier Name'
    }
  ],
  SORT_DIRECTION: [
    {
      value: 'asc',
      label: 'Ascending'
    },
    {
      value: 'desc',
      label: 'Descending'
    }
  ],
  CHILD_RIDER_UNITS: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
  UNDERWRITING_CLASS_ENUM: {
    Unknown: 0,
    'Super Preferred': 1,
    'Preferred Plus': 2,
    Preferred: 3,
    'Standard Plus': 4,
    Standard: 5
  },
  TABLE_RATING_ENUM: {
    'Table A': 1,
    'Table B': 2,
    'Table C': 3,
    'Table D': 4,
    'Table E': 5,
    'Table F': 6,
    'Table G': 7,
    'Table H': 8,
    'Table I': 9,
    'Table J': 10,
    'Table K': 11,
    'Table L': 12,
    'Table M': 13,
    'Table N': 14,
    'Table O': 15,
    'Table P': 16,
    'Table Q': 17,
    'Table R': 18,
    'Table S': 19,
    'Table T': 20,
    'Table U': 21,
    'Table V': 22
  },
  TABLES: [
    'Table A',
    'Table B',
    'Table C',
    'Table D',
    'Table E',
    'Table F',
    'Table G',
    'Table H',
    'Table I',
    'Table J',
    'Table K',
    'Table L',
    'Table M',
    'Table N',
    'Table O',
    'Table P',
    'Table Q',
    'Table R',
    'Table S',
    'Table T',
    'Table U',
    'Table V'
  ],
  PAYMENT_MODES: [
    {
      value: 'monthly',
      label: 'Monthly'
    },
    {
      value: 'quarterly',
      label: 'Quarterly'
    },
    {
      value: 'semi_annual',
      label: 'Semi Annually'
    },
    {
      value: 'annual',
      label: 'Annually'
    }
  ],
  CUSTOM_ACTIONS: {
    // INSTANT_ISSUE: [
    //   'ethos'
    // ],
    ETICKETS: ['applicint', 'anico', 'nmb_term_eticket', 'nmb_whole_life_eticket', 'paclife', 'protective', 'sbli']
  },
  AMBEST_SORTING: {
    'A++': 13,
    'A+': 12,
    A: 11,
    'A-': 10,
    'B++': 9,
    'B+': 8,
    B: 7,
    'B-': 6,
    'C++': 5,
    'C+': 4,
    C: 3,
    'C-': 2,
    D: 1,
    NA: 0
  },
  RATE_TYPES: [
    { label: 'Cap Rate', key: 'cap_rate' },
    { label: 'Triggered Rate', key: 'performance_trigger' },
    { label: 'Participation Rate', key: 'participation_rate' },
    { label: 'Spread', key: 'spread_rate' },
    { label: 'Fixed Rate', key: 'fixed_rate' }
  ]
};
